const configuration = {
  //  baseUrl: "http://localhost:8000/",
  baseUrl: "https://dev.vaisnavamarriage.com/",
  //  baseUrl: "https://vaisnavamarriage.com/",

  apis: {
    login: "api/login",
    register: "api/register",
    forgetPassword: "api/password-reset",
    resetPassword: "api/password-reset",
    adminLogin: "api/adminLogin",
    filter: "api/filter",
    saveProfile: "api/saveProfileSection",
    savePhoto: "api/savePhoto",
    singleUser: "api/getUserDetails",
    matches: "api/matches",
    getMatches: "api/getMatches",
    changeStatus: "/api/changeStatus", //accept/reject matches
    sendMatches: "api/sendMatches",
    addNotes: "api/addNotes", // SAVE ADMIN NOTES API
    getNotes: "api/getNotes", //GET ADMIN NOTES API
    changePassword: "api/changePassword",
    sendRequest: "api/sendRequest",
    adminApprovalPending: "api/adminApprovalPending",
    adminApproval: "api/adminApproval",
    updateNote: "/api/updateNote",
    deleteNote: "/api/deleteNote",
    searchAndSent: "api/searchAndSendMatches",
    userFilter: "api/userfilter",
    adminApprove: "api/approveRequests",
    userGetRequest: "api/userApprovalPending",
    userApproval: "api/userApproval",
    getNotification: "api/getNotification",
    approveRequest: "/api/getApprovedRequests",
    readNotification: "/api/readNotification",
    sendApproval: "api/sendApproval",
    getAllQuestionnaireRequests: "api/getAllQuestionnaireRequests",
    questionnaireApproval: "api/questionnaireApproval",
    getQuestions: "api/getQuestions",
    overAllApproval: "api/overAllApproval",
    getAcceptedUsers: "api/getAcceptedUsers",
    advanceSearch: "api/search",
    deleteUser: "api/deleteUser",
    updateMarital: "api/updateMarital",
    questionnaireMaritalStatus: "api/questionnaireMaritalStatus", // POST { adminId, reqId, maritalStatus, marriedViaVmb, marriedDate, isGuided?, guidedUserId?, guidedUser? }
    getAllMarried: "api/married",
    markAsMarriedFromFixed: "api/markAsMarriedFromFixed",
    getEngagedOrFixed: "api/engagedOrFixed",
    changePassword: "api/changePassword",
    uploadFiles: "api/uploadFile",
    addEmail: "api/addEmail",
    verifyEmail: "api/verifyAndSave",
    getDeletedUsers: "api/getDeletedUsers",
    changePrimaryEmail: "api/changePrimaryEmail",
    deleteEmail: "api/deleteEmail",
    blockUser: "api/blockUser",
    getBlockedUsers: "api/getBlockedUsers",
    requestDetail: "api/getRequestByUserId",
    getSuggestionHistory: "api/suggestionHistory",
    getAllUserVerifyRequests: "api/getAllUserVerifyRequests",
    userVerifyApproval: "api/userVerifyApproval",
    userVerify: "api/userVerification",
    getReport: "api/getReport",
    getSuggestion: "api/suggestionDetailsByUserId",
    userChangeStatus: "api/changeUserStatus",
    addTask: "api/addAdminTaskNotes",
    getTask: "api/getAdminTaskNotes",
    updateTask: "api/updateAdminTaskNote",
    deleteTask: "api/deleteAdminTaskNote",
    adminChangeStatus: "api/adminChangeStatus",
    saveQuestions: "api/saveQuestions",
    getAnswers: "api/getAnswers",
    adminProfileLog: "api/adminProfileLog",
    adminactivity: "api/adminActivityLog",
    userActivityLog: "api/userActivityLog",
    userProfileLog: "api/userProfileLog",
    getAllAdmins: "api/getAllAdmins",
    getAllAdminSuggestions: "api/getAllSuggestions",
    adminSuggestionReject: "api/adminReject",
    updatePhoneNumber: "api/updatePhoneNumber",
    adminRegister: "api/adminRegister",
    adminUpdate: "api/adminUpdate",
    mentorVerify: "api/mentorVerify",
    courseVerify: "api/courseVerify",
    adminPasswordUpdate: "api/adminPasswordUpdate",
    inTalkStatus: "api//inTalkStatus",
    getCoordinatorSuggestions: "api/getCoordinatorSuggestions",
    approveCoordinatorSuggestion: "api/approveCoordinatorSuggestion",
    questionnaireInTalkStatus:"api/questionnaireInTalkStatus",
    getFavouriteUsers: "api/getFavouriteUsers", // GET ?adminId= -> { status, message, data: [favouriteUsers] }
    markFavouriteUser: "api/markFavouriteUser", // POST { adminId, userId } -- first-time favourite
    updateFavouriteUser: "api/updateFavouriteUser",
    userStatusDetails: "api/userStatusDetails", // GET ?userId= -> { status, message, data: { group: { state: [entries] } } }
  },
};

export default configuration;
